import Types from "./Types";

const INITIAL_STATE = {
  user: null,
  token: null,
  isLoading: false,
  governments: [],
  regions: [],
  grades: [],
  majors: [],
};

export default function auth(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.LOGIN_USER_SUCCESS: {
      if (!payload.user.data.data.token) {
        window.localStorage.setItem("userID", payload.data.user_id);
      } else {
        window.localStorage.setItem("token", payload.user.data.data.token);
      }
      return {
        ...state,
        token: payload.user.data.data.token,
      };
    }
    case Types.FORGET_PASSWORD_SUCCESS: {
      window.localStorage.setItem("userID", payload.data.user_id);
      window.location.replace("/forget-password/otp");
      return {
        ...state,
      };
    }
    case Types.FORGET_PASSWORD_OTP_USER_SUCCESS: {
      window.localStorage.setItem("token", payload.data.data.token);
      window.localStorage.setItem("userID", payload.data.data.user_id);
      window.location.replace("/forget-password/change-password");
      return {
        ...state,
      };
    }
    case Types.RESET_PASSWORD_SUCCESS: {
      window.location.replace("/login");
      localStorage.clear();
      return {
        ...state,
      };
    }
    case Types.REGISTER_USER_SUCCESS: {
      window.localStorage.setItem("userID", payload.data.id);
      return {
        ...state,
      };
    }

    case Types.LOGOUT_USER_SUCCESS: {
      window.localStorage.clear();
      return {
        ...state,
        user: null,
        token: null,
      };
    }
    case Types.GET_SYSTEM_GOVERNMENT_SUCCESS: {
      return {
        ...state,
        governments: payload.data,
      };
    }

    case Types.GET_SYSTEM_REGION_SUCCESS: {
      return {
        ...state,
        regions: payload.data,
      };
    }

    case Types.GET_SYSTEM_GRADES_SUCCESS: {
      return {
        ...state,
        grades: payload.data,
      };
    }

    case Types.GET_SYSTEM_MAJORS_SUCCESS: {
      return {
        ...state,
        majors: payload.data,
      };
    }

    // Misc
    case Types.SET_AUTH_IS_LOADING: {
      const isLoading = payload;
      return {
        ...state,
        isLoading: isLoading,
      };
    }

    default: {
      return state;
    }
  }
}
